import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';

import Link from '@buyside/components/presentation/Link/link';

import styles from '../ideaStatusBarStyles.scss';

const IdeaStatusContest: FC<{ isMultiple: boolean }> = ({ isMultiple }) => (
  <div className={styles.ideaStatusContest}>
    <FontAwesomeIcon className={styles.faIcon} icon={faExclamationCircle} />
    Your Idea is being reviewed by SumZero admins for inclusion in the contest
    {isMultiple ? 's' : ''}. It is not yet visible to the public. Contact{' '}
    <Link to="mailto:support@sumzero.com">support@sumzero.com</Link> with any questions.
  </div>
);

export default IdeaStatusContest;
